import React, { Component } from 'react';

import Radio from './Radio/Radio';
import classes from './RadioGroup.module.css';
import PropTypes from 'prop-types';

class RadioGroup extends Component {
  _setValue = (value) => {
    this.props.radioClicked(value);
  };

  _renderRadios = () => {
    return this.props.options.map((o, i) => {
      return (
        <Radio
          key={i}
          style={this.props.radioStyle}
          circleStyle={this.props.radioCircleStyle}
          textStyle={this.props.radioTextStyle}
          withCheckmark={this.props.withCheckmark}
          displayAsButton={this.props.displayAsButton}
          optionText={o.text}
          optionValue={o.value}
          selected={o.value === this.props.selected}
          radioClicked={this._setValue.bind(this, o.value)}
        />
      );
    });
  };

  render() {
    return (
      <div className={classes.RadioGroup} style={this.props.style}>
        {this._renderRadios()}
      </div>
    );
  }
}

RadioGroup.propTypes = {
  options: PropTypes.array.isRequired,
  selected: PropTypes.any.isRequired,
  radioClicked: PropTypes.func.isRequired,
};

RadioGroup.defaultProps = {
  style: {},
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/UI/RadioGroup/RadioGroup.js